import React, { useEffect, useState } from 'react';
import { Link } from 'react-scroll';
import Header from '../Header/Header';
import './Achievement.css';
import Achieve from '../../FakeData/Achieve'
import AOS from 'aos';
import 'aos/dist/aos.css';



const Achievement = () => {


    useEffect(() => {
        AOS.init({ duration: 1000 })
    })

    const [achieve, setAchieve] = useState(Achieve);
    return (
        <div>
            <div className="head">
                <Header></Header>
                {
                    achieve.map(achieve => <Ach achi={achieve}></Ach>)
                }
            </div>
        </div>
    );
};



const Ach = (props) => {

    const { course, img, by } = props.achi;

    return (
        <div className="achieve">
            <div className=" container" data-aos="fade-down">
                <div className="content offset-md-2 col-md-8 col-sm-12 col-12">
                    <h3> {course} </h3>
                    <h5>By:  {by} </h5>
                </div>
                <div className="certificate offset-md-2 col-md-8 col-sm-12 col-12">
                    <img src={img} alt="" />
                </div>
            </div>
        </div>
    );
}


export default Achievement;